<template>
    <div class="builder-tabs-block block" id="LearningMyPlatformSettings">
        <v-form id="mainInfo">
            <v-input
                name="telegram.login"
                title="Заголовок*"
                v-model="formData.title"
                class="input__field"
                rules="required"
                counter
                :max="60"
                @change="hasBeenChanged = true"
                @focusout="checkValid('title')"
                :error="errors.title"
            />
            <v-input
                v-model="formData.subtitle"
                name="course.subtitle"
                title="Подзаголовок*"
                class="input__field"
                rules="required"
                counter
                :max="60"
                @change="hasBeenChanged = true"
                @focusout="checkValid('subtitle')"
                :error="errors.subtitle"
            />
            <div class="course-header-tags" v-if="$route.params.category === 'courses'">
                <v-select
                    name="category"
                    title="Категория*"
                    class="abstract-new-course-step__control"
                    placeholder="Выберите категорию"
                    v-model="formData.category"
                    :options="tags.categories"
                    @focusout="checkValid('category')"
                    :error="errors.category"
                />
                <v-select
                    class="abstract-new-course-step__control"
                    title="Уровень*"
                    name="level"
                    placeholder="Выберите уровень"
                    v-model="formData.level"
                    :options="tags.levels"
                    @focusout="checkValid('level')"
                    :error="errors.level"
                />
                <v-select
                    class="abstract-new-course-step__control"
                    title="Язык*"
                    name="language"
                    placeholder="Выберите язык"
                    v-model="formData.language"
                    :options="tags.languages"
                    @focusout="checkValid('language')"
                    :error="errors.language"
                />
                <!--   <v-taplink-textarea
                       name="text"
                       title="Описание"
                       v-model="formData.description"
                       class="textarea__field"
                       @change="hasBeenChanged = true"
                   />-->
            </div>
            <div v-if="category === 'courses'" class="abstract-new-course-step">
                <div class="abstract-new-course-step__title">
                    <h2 class="title">Обложка курса</h2>
                    <div class="abstract-new-course-step__title-caption">
                        Выделите свой курс среди остальных с помощью красивого изображения. О том как сделать красивую
                        обложку вы можете посмотреть
                        <a class="abstract-new-course-step__title-caption-link" href="#">здесь.</a>
                        Ключевые требования: 750x422 пикселей; .jpg, .jpeg, .gif, или .png.; изображение не должно
                        содержать текст.
                    </div>
                </div>
                <div class="abstract-new-course-step__content">
                    <div class="create-course-box__body-content">
                        <div class="uploader-box">
                            <div class="uploader-box__view">
                                <v-icon v-if="!formData.cover" src="img" />
                                <img v-else :src="formData.cover.url" alt="" />
                            </div>
                            <div v-if="!formData.cover.url" class="uploader-box__file" v-upload:cover="coverUpload">
                                <span class="btn">Выбрать фото</span>
                            </div>
                            <div class="uploader-box__result" v-else>
                                <div class="upload-result">
                                    <span>{{ formData.cover.name }}</span>
                                    <button class="__clean-btn" type="button" @click.stop="cleanById('cover')">
                                        <v-icon src="delete" />
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div>
                <div class="title">Промовидео для курса</div>
                <p>
                    После просмотра качественного промовидео вероятность того, что студенты запишутся на ваш курс, может
                    увеличиться в 5 раз. А при наличии исключительно хороших видео — даже в 10 раз.
                </p>
                <div class="block">
                    <VideoUpload
                        @uploadFileData="coverUpload"
                        :cleanById="cleanById"
                        :video-data="{
                            video: formData.video,
                            image: formData.image
                        }"
                        :show-key="showKey"
                        :controls="controls"
                        :creating-new-course="true"
                    />
                </div>
            </div>
        </v-form>
    </div>
</template>

<script>
import VButton from "../../../../../../common/components/VButton";
import VideoUpload from "../../../../../course-module/course-creating/components/VideoUpload";
import CourseCover from "../components/CourseCover";
import { uploadFile } from "../../../../../course-module/course-creating/services/course-creating-service";
import { UploadDirective } from "../../../../../../directives/uploadDirective";

export default {
    name: "CourseMainInfo",
    /* $_veeValidate: {
            validator: "new"
        },*/
    directives: { upload: UploadDirective },
    components: {
        VButton,
        VideoUpload,
        CourseCover
    },
    props: {
        id: {},
        category: String,
        apiData: Object,
        tags: Object
    },
    data() {
        return {
            showKey: 0,
            controls: [
                {
                    id: 1,
                    label: "Видео",
                    name: "",
                    preview: "Добавить видео",
                    size: "",
                    isActive: false,
                    disable: false,
                    directiveId: "video"
                },
                {
                    id: 2,
                    label: "Обложка",
                    name: "",
                    preview: "Добавить обложку видео",
                    size: "",
                    isActive: false,
                    disable: false,
                    directiveId: "image"
                }
            ],
            errors: {},
            formData: {
                title: "",
                subtitle: "",
                category: null,
                level: null,
                language: null,
                image: {},
                cover: {},
                video: {}
            },
            loading: false,
            timeout: null,
            hasBeenChanged: false,
            courseTags: {},
            firstLoad: true
        };
    },
    mounted() {
        this.$nextTick(() => {
            this.onLoad();
        });
    },
    /*    beforeMount() {
                            window.addEventListener("beforeunload", this.preventNav);
                            this.$once("hook:beforeDestroy", () => {
                                window.removeEventListener("beforeunload", this.preventNav);
                            });
                        },*/
    watch: {
        formData: {
            handler(newVal, oldVal) {
                if (newVal) {
                    this.debounceSave();
                }
            },
            deep: true
        }
    },
    methods: {
        onLoad() {
            if (this.apiData) {
                const api = this.apiData;
                this.formData = {
                    ...this.formData,
                    title: api.title,
                    subtitle: api.subtitle,
                    category: api.category?.id,
                    language: api.language?.id,
                    level: api.level?.id
                };
                if (api.cover) {
                    this.$set(this.formData, "cover", api.cover);
                }
                if (api.video) {
                    const video = api.video;
                    this.$set(this.formData, "video", video);
                    this.showKey++;
                    this.controls[0].isActive = true;
                    this.controls[0].name = video.name;
                }
                if (api.image) {
                    this.$set(this.formData, "image", api.image);
                    this.controls[1].name = api.image.name;
                    this.controls[1].isActive = true;
                    this.showKey++;
                }
            }
            this.firstLoad = false;
        },
        debounceSave() {
            if (this.timeout) {
                clearTimeout(this.timeout);
                this.timeout = null;
            }
            this.timeout = setTimeout(() => {
                this.saveData();
            }, 400);
        },
        checkValid(field) {
            if (!this.formData[field]) {
                this.errors[field] = "Обязательно для заполнения";
            } else {
                this.errors[field] = null;
            }
            console.log(this.errors);
        },
        saveData() {
            if (this.firstLoad) return;
            const data = {
                title: this.formData.title,
                subtitle: this.formData.subtitle,
                image_id: this.formData.image?.id,
                video_id: this.formData.video?.id,
                cover_id: this.formData.cover?.id,
                category_id: this.formData.category,
                language_id: this.formData.language,
                level_id: this.formData.level
            };
            this.$emit("updateData", data);
        },
        preventNav(event) {
            if (!this.hasBeenChanged) return;
            event.preventDefault();
            event.returnValue = "asddsaasd";
        },
        cleanById(directiveId) {
            this.formData[directiveId] = {
                name: "",
                url: "",
                id: ""
            };
            if (directiveId !== "cover") {
                this.controls.find(control => control.directiveId === directiveId).isActive = false;
                this.showKey--;
            }
        },
        coverUpload(file) {
            this.$api.files
                .upload(file.file)
                .then(res => {
                    const data = res.data.data;
                    this.formData[file.id] = data;
                    if (file.id !== "cover") {
                        const targetControl = this.controls.find(item => item.directiveId === file.id);
                        targetControl.isActive = true;
                        targetControl.name = file.file.name;
                        targetControl.size = Math.ceil(file.file.size / (1024 * 1024)).toFixed(2);
                    }
                    this.showKey++;
                    this.hasBeenChanged = true;
                })
                .catch(err => {
                    this.notify({ title: "Не удалось загрузить изображение", text: err.data.message, type: "error" });
                });
        }
    },
    beforeDestroy() {
        window.removeEventListener("beforeunload", this.preventNav);
    }
};
</script>
<style lang="scss">
#LearningMyPlatformSettings {
    @media (max-width: 769px) {
        .uploader-descriptor__view {
            display: block;
            &-preview {
                height: 196px;
                video {
                    max-height: 196px !important;
                    height: 100% !important;
                }
            }
        }
    }
    /*  @media (max-width: 740px) {
        margin-top: 65px;
    }*/

    .course-header-tags {
        margin-bottom: 20px;

        .abstract-new-course-step__control {
            margin-bottom: 20px;
        }
    }

    .uploader-descriptor {
        width: 100%;

        p span {
            display: none;
        }

        svg {
            fill: #ffc107 !important;
        }

        .uploader-descriptor__control,
        .uploader-descriptor__view {
            width: 45%;
            @media (max-width: 764px) {
                display: flex;
                flex-direction: column;
                align-items: flex-start;
                max-width: 400px;
            }

            .uploader-descriptor__view-preview {
                margin: 0;
                width: 100%;

                #video_player {
                    width: 100%;
                    max-height: 145px;
                }

                video {
                    width: 100%;
                    max-height: 145px;
                }
            }
        }

        .uploader-descriptor__view {
            @media (max-width: 764px) {
                display: flex;
                flex-direction: column;
                max-width: 400px;
            }
        }

        .uploader-descriptor__control-item {
            width: 100%;
        }
    }

    .my-button {
        outline: none;
        height: 40px;
        font-family: "Roboto", sans-serif;
        font-style: normal;
        font-weight: 500;
        font-size: 16px;
        line-height: 24px;
        color: #1d2228;
        padding: 0 10px;
    }

    .outlined {
        background: #ffffff;
        border: 1px solid #ffc107;
        border-radius: 6px;
    }

    .filled {
        background: #ffc107;
        border-radius: 6px;
    }

    .save {
        display: none;
        @media (max-width: 1025px) {
            display: block;
            width: 100%;
            margin: 40px 0;
            height: 48px !important;
        }
    }

    .learning-box__body-head-wrapper {
        padding: 0;
    }

    .small-fixed-top {
        display: none;
        @media (max-width: 630px) {
            background: #ffffff;
            width: 100%;
            height: 56px;
            position: fixed;
            top: 56px;
            left: 0;
            box-shadow: 0px 1px 4px rgba(57, 70, 111, 0.06), 0px 6px 20px rgba(57, 70, 111, 0.08);
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 0 16px;
            z-index: 1;
            .title {
                font-family: "Roboto", sans-serif;
                font-weight: bold;
                font-size: 18px;
                line-height: 24px;
                color: #1d2228;
            }
            .icon {
                font-size: 24px;
            }
        }
    }

    #mainInfo {
        width: 604px;
        @media (max-width: 834px) {
            width: 100%;
        }

        .input__field,
        .textarea__field {
            margin-bottom: 25px;
        }

        .title {
            font-family: "Roboto", sans-serif;
            margin-bottom: 10px;
            font-size: 32px;
            color: #1d2228;
            font-weight: bold;
            line-height: 40px;
        }

        p {
            font-family: "Roboto", sans-serif;
            font-size: 14px;
            line-height: 20px;
            color: #58606e;
            width: 520px;
            @media (max-width: 834px) {
                width: 100%;
            }
        }

        svg {
            font-size: 24px;
            fill: #8e99ab;
        }

        .block {
            margin-top: 24px;
            display: flex;
            justify-content: space-between;

            .uploader-descriptor {
                @media (max-width: 765px) {
                    .uploader-descriptor__view {
                        width: 100%;
                        background-color: white;

                        .uploader-descriptor__view-preview {
                            height: auto;
                        }
                    }
                    .uploader-descriptor__control {
                        width: 100%;
                    }
                }
            }

            @media (max-width: 630px) {
                flex-direction: column;
                .right {
                    order: 0;

                    video {
                        min-width: 100%;
                    }
                }
                .left {
                    width: 100% !important;
                    order: 1;
                }
            }

            .left {
                width: 336px;
                margin-right: 32px;

                .v-button {
                    margin-top: 18px;
                    margin-bottom: 18px;
                }
            }

            .right {
                flex: 1 1 auto;

                &-header {
                    font-family: "Roboto", sans-serif;
                    font-weight: 500;
                    font-size: 14px;
                    line-height: 24px;
                    display: flex;
                    align-items: center;
                    color: #1d2228;

                    div {
                        margin-left: 10px;
                        font-family: "Roboto", sans-serif;
                        font-weight: 500;
                        font-size: 12px;
                        line-height: 14px;
                        color: #58606e;
                    }
                }
            }
        }

        .input-block {
            display: flex;
            align-items: flex-end;

            .form-group {
                flex: 1 1 auto;
            }

            svg {
                margin: 0 12px;
                margin-bottom: 7.5px;
            }
        }

        .file-input {
            position: relative;
            margin-bottom: 16px;

            .label {
                font-family: "Roboto", sans-serif;
                font-weight: 500;
                font-size: 14px;
                line-height: 24px;
                color: #58606e;
            }

            .input {
                border: 1px solid #c8d1e0;
                box-sizing: border-box;
                border-radius: 6px;
                height: 40px;
                display: flex;
                justify-content: space-between;
                align-items: center;
                padding: 0 12px;

                &.active {
                    background-color: #f5f7fa;
                    border: 1px solid #f5f7fa;
                }

                &.active .svg-icon {
                    cursor: pointer;
                }
            }
        }

        .buttons-group {
            display: flex;
            margin-top: 24px;
            @media (max-width: 630px) {
                button {
                    width: 48%;
                    justify-content: center;
                    padding: 0 !important;
                }
            }

            button {
                height: 40px;
                padding: 0 32px;
            }

            button:first-child {
                border: 1px solid #ffc107;
                color: #8b5c00;
                margin-right: 16px;
            }
        }
    }

    .abstract-new-course-step {
        &__title {
            margin-bottom: 40px;

            @media (max-width: 769px) {
                margin-bottom: 24px;
            }
        }

        &__title-name {
            font-size: 32px;
            color: #1d2228;
            font-weight: bold;
            line-height: 40px;

            @media (max-width: 769px) {
                font-size: 20px;
                line-height: 28px;
            }
        }

        &__title-caption {
            font-size: 14px;
            color: #58606e;
            max-width: 543px;
            line-height: 24px;

            @media (max-width: 769px) {
                margin-top: 9px;
                line-height: 20px;
            }
        }

        &__title-caption-link {
            color: #ffc107;

            &:hover {
                color: #faac15;
            }
        }

        &__content {
            max-width: 544px;
            min-height: 300px;
        }

        &__input {
            max-width: 544px;

            &-error {
                border: 1px solid #f65844;
                border-radius: 6px;
            }
        }

        &__error {
            margin-top: 10px;
            color: red;
        }

        &__control {
            &:not(:last-child) {
                margin-bottom: 24px;
            }
        }

        &__form-group-caption {
            font-size: 12px;
            font-weight: 500;
            color: #9ca1ab;
            text-align: right;
        }

        .uploader-box__view img {
            visibility: visible;
        }

        .uploader-box__result {
            display: block;
        }
    }
}
</style>
